import { render, staticRenderFns } from "./TocasSinResumen.vue?vue&type=template&id=14031bca"
import script from "./TocasSinResumen.vue?vue&type=script&lang=js"
export * from "./TocasSinResumen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports